import React, {Component} from 'react';
import { lexCBFetchData } from '../../../actions/chat/lexCB';
import { connect }        from 'react-redux';
import { withRouter }     from 'react-router';
import PubSub             from 'pubsub-js';
import PropTypes          from 'prop-types';

var ERROR_MSG  = 'I didn\'t understand you, what would you like to do?';
var NO_MATCH   = 'We couldn\'t find anything that matched that.';
var NO_MATCH_1 = 'We couldn\'t find anything that matched. Here are a few search results that might help.';
var self;
/**
 * This LookUp is responsible for sending requests to Lex and 
 * recieving and handling the new messages. 
 */
export class LookUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      result: [],
      link: [],
    };

    this.triggerNext = this.triggerNext.bind(this);
  }

  componentWillMount() {
    self = this; //Used so old components don't get rewritten
    const { steps } = this.props;
    self.props.fetch(steps.search.value);//Handle new user message
  }

  componentDidMount() {
    //Used to avoid too many calls due to rendering
    this.token = PubSub.subscribe('lexCB.response', this.subscriber.bind(this));
  }

  subscriber(msg, data) {
    var str = ERROR_MSG; //Handles the possible responses
    if(data.message) {
      try {
        var json = JSON.parse(data.message);
        if(json.type === 'plain') {
          str = json.message;
        } else if (json.type === 'search') {
        var search = JSON.parse(json.message);
          if(search.length === 0) {
            str = NO_MATCH;
          } else {
            str = NO_MATCH_1;    
        }
      } else if(json.type === 'dynamic') {
        var dynamic = json.message;
        self.setState({link: json.message});
        /*dynamic.map((msg,index) => {
          console.log(msg.message.link);
        });*/
        
        if(dynamic.length === 0){
          str = NO_MATCH;
        } else {
          dynamic.forEach(function(item) {
            if(item.type === 'message') {
              str = item.message;
            } 
          });
        }
      }
    } catch (e) {
        if(typeof data.message !== 'object') {
          str = data.message;
        }
      }    
  } else {
    str = data.Status;
  }
  self.setState({result: str});//Use self to update to the set
  self.triggerNext();//Trigger next step

}

  triggerNext() {
      // this.props.triggerNextStep({trigger: 'fun'});
      this.setState({ trigger: true }, () => {
        this.props.triggerNextStep();
      });
  }
    
  render() {
    const { result, link} = this.state;
    /** 
    * link.map attaches additional links if something was added to link state
    * {result} is lex response
    */
    return (
        <div>
            {result}
            {link.map((msg, index) =>
          ( 
          <a href ={msg.message.link}> <br />{msg.message.link}</a>
          ))}
        </div>
    );
  }
}

LookUp.propTypes = {
  steps: PropTypes.object,
  triggerNextStep: PropTypes.func,
};

LookUp.defaultProps = {
  steps: undefined,
  triggerNextStep: undefined,
};

const mapStateToProps = state => {
  return {
    chat: state.chat.chat.lexCB,
    hasErrored: state.chat.chat.lexCBHasErrored,
    isLoading: state.chat.chat.lexCBIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLex: (host, msg) => dispatch(lexCBFetchData(host, msg))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LookUp));